import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';

import { Header as HeaderBernie } from '@gc/global-components';
import { MyList } from 'components/common/header/my-list';
import { Qualtrics } from 'components/common/header/qualtrics';

export interface HeaderProps {
  className?: string;
}

export const Header: React.FunctionComponent<HeaderProps> = ({ className }) => (
  <HeaderBernie className={className}>
    <MyList />
    {/* the Qualtrics experiments below are for different POSes and will not have more than one bucketed in */}
    <AbacusExperiment name="PWA_Qualtrics_Intercept">
      <AbacusControl />
      <AbacusVariant bucket={1}>
        <Qualtrics />
      </AbacusVariant>
    </AbacusExperiment>
    <AbacusExperiment name="PWA_Qualtrics_Intercept_for_BEX_Rest_of_World">
      <AbacusControl />
      <AbacusVariant bucket={1}>
        <Qualtrics />
      </AbacusVariant>
    </AbacusExperiment>
    <AbacusExperiment name="PWA_Qualtrics_Intercept_for_Comet">
      <AbacusControl />
      <AbacusVariant bucket={1}>
        <Qualtrics />
      </AbacusVariant>
    </AbacusExperiment>
  </HeaderBernie>
);
Header.displayName = 'Header';
